import(/* webpackMode: "eager", webpackExports: ["StaticClientLayout"] */ "/home/runner/work/ensite/ensite/packages/client/src/app/(static)/[locale]/[host]/static/StaticClientLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ensite/ensite/packages/client/src/app/server-layout.tsx");
